import { createSlice } from '@reduxjs/toolkit';

export const eventStatusSlice = createSlice({
  name: 'eventStatus',
  initialState: {
    eventInactive: false,
    userId: null,
    eventId: null,
    eventUniqueNo: null,
  },
  reducers: {
    eventUpdate: (state, action) => {
      const { isInactive, userId, eventId, eventUniqueNo } = action.payload;
      return {
        ...state,
        eventInactive: isInactive,
        userId: userId,
        eventId: eventId,
        eventUniqueNo: eventUniqueNo,
      };
    },
    updateEventStatus: (state, action) => {
      const { isInactive } = action.payload;
      return { ...state, eventInactive: isInactive };
    },
    clearEventStatus: (state, action) => {
      return {};
    },
  },
});

export const { eventUpdate, updateEventStatus, clearEventStatus } =
  eventStatusSlice.actions;

export default eventStatusSlice.reducer;
